import { FaBox, FaUser, FaShoppingCart, FaSave } from "react-icons/fa"
import SearchBar from "../components/ui/components/SearchBar";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Selector from "../components/ui/components/Selector";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import DinamicButton from "../components/ui/components/DinamicButton";
import FilterButton from "../components/ui/components/FilterButton";
import Modal from "../components/ui/Modal"
import AddIcon from "@mui/icons-material/Add";
import FilterHeadersDialog from "../components/dialogs/FilterHeadersDialog";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import InputFormValue from "../components/ui/components/InputFormValue";
import { CircularProgress } from "@mui/material";
import ItemRowInventarioStakeholders from "../components/inventario/ItemRowInventarioStakeholders";
import { FormatDateString } from "../utils/FormatDate";
import ParseNumberToFloat from "../utils/helpers/ParseNumberToFloat";
import { months, years } from "../utils/rawData/dateValues"
import { useNavigate } from "react-router-dom";
import PaginationItem from "../components/ui/components/Pagination";

const Inventario = () => {

  const navigate = useNavigate()

  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(1);

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(1)

  const [record, setRecord] = useState([]);
  const [workers, setWorkers] = useState([])

  const [loadingStatus, setLoadingStatus] = useState(false);
  const [createNewItemModal, setCreateNewItemModal] = useState(false);

  const [stakeholderSelected, setStakeholderSelected] = useState(null)
  const [purchaseSelected, setPurchaseSelected] = useState(null)

  const [stakeholders, setStakeholders] = useState([])
  const [purchases, setPurchases] = useState([])

  const [uploadingStatus, setUploadingStatus] = useState(false)
  const [editItemModal, setEditItemModal] = useState(false)
  const [editItem, setEditItem] = useState(null)

  // Si el estado es "En mantenimiento" o "Fuera de uso", desasignar automáticamente al usuario
  useEffect(() => {
    if (!editItem) return
    if (editItem.status === "En mantenimiento" || editItem.status === "Fuera de uso") {
      if (editItem.userAssigned) {
        setEditItem(prev => ({ ...prev, userAssigned: null }))
      }
    }
  }, [editItem])

  const [selectedMonth, setSelectedMonth] = useState("")
  const [selectedYear, setSelectedYear] = useState("")
  const [selectedWorker, setSelectedWorker] = useState("")
  const [selectedStatus, setSelectedStatus] = useState("")

  // Categorías y subcategorías

  const [categories, setCategories] = useState([])
  const [subcategories, setSubcategories] = useState([])

  const [selectedCategory, setSelectedCategory] = useState("")
  const [selectedSubcategory, setSelectedSubcategory] = useState("")

  const itemStatus = [
    {label: "Disponible", value: "Disponible"}, 
    {label: "En uso", value: "En uso"},
    {label: "En mantenimiento", value: "En mantenimiento"}, 
    {label: "Fuera de uso", value: "Fuera de uso"},
  ]

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/getUsersIds/getWorkerUsers`)
      setWorkers(response.data)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los usuarios: " + error)
    }
  }

  const getRecord = async () => {
    try {
      setLoadingStatus(true)
      let url = `${BACKEND}/api/inventario?limit=${limit}&page=${page}`
      if (search) url += `&where[buy.stakeholderProduct.name][like]=${search}`
      if (selectedMonth) url += `&where[buy.month][equals]=${selectedMonth}`
      if (selectedYear) url += `&where[buy.year][equals]=${selectedYear}`
      if (selectedWorker) url += `&where[userAssigned][equals]=${selectedWorker}`
      if (selectedStatus) url += `&where[status][equals]=${selectedStatus}`
      if (selectedCategory) url += `&where[buy.stakeholderProduct.category][equals]=${selectedCategory}`
      if (selectedSubcategory) url += `&where[buy.stakeholderProduct.subcategory][equals]=${selectedSubcategory}`
      const response = await axios.get(url)
      setRecord(response.data.docs)
      setTotalDocs(response.data.totalDocs || 0)
      setTotalPages(response.data.totalPages || 1)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los registros: " + error)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getStakeholders = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/stakeholders?limit=0`)
      setStakeholders(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los stakeholders: " + error)
    }
  }

  const getPurchasesForStakeholder = async (stakeholderId) => {
    try {
      const response = await axios.get(`${BACKEND}/api/comprasStakeholders?limit=0&where[stakeholder][equals]=${stakeholderId}&depth=1`)
      setPurchases(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las compras: " + error)
    }
  }

  const resetNewItemForm = () => {
    setNewItem({
      stakeholder: "",
      purchase: "",
      itemName: "",
      brand: "",
      unitPrice: "",
      purchaseDate: "",
      serialNumber: "",
      description: "",
      status: "Disponible",
      quantity: 1
    })
    setStakeholderSelected(null)
    setPurchaseSelected(null)
    setPurchases([])
  }

  const createInventoryItem = async () => {
    try {
      if (!newItem.stakeholder || !newItem.purchase) {
        toast.error("Completa todos los campos obligatorios")
        return
      }

      setUploadingStatus(true)

      const quantity = Number(newItem.quantity) || 1;
      const itemsToCreate = [];
      
      // Crear un array con la cantidad de ítems
      for (let i = 0; i < quantity; i++) {
        itemsToCreate.push({
          stakeholder: newItem.stakeholder,
          stakeholderProduct: purchaseSelected?.stakeholderProduct?.id || "",
          buy: newItem.purchase, // Referencia a la compra usando el campo 'buy' de la colección
          itemName: newItem.itemName || purchaseSelected?.stakeholderProduct?.name || "",
          brand: newItem.brand || purchaseSelected?.stakeholderProduct?.brand || "",
          unitPrice: newItem.unitPrice ? Number(newItem.unitPrice) : purchaseSelected?.unitPrice || 0,
          purchaseDate: newItem.purchaseDate || purchaseSelected?.paymentDate || new Date().toISOString(),
          serialNumber: newItem.serialNumber || "",
          description: newItem.description || purchaseSelected?.description || "",
          status: "Disponible",
          // No incluir quantity, assignedTo, assignedDate, userAssigned ya que cada registro es un ítem individual
        });
      }
      
      // Crear todos los ítems
      const promises = itemsToCreate.map(item => 
        axios.post(`${BACKEND}/api/inventario`, item)
      );
      
      await Promise.all(promises);
      
      toast.success(`${quantity} ítem(es) agregado(s) al inventario correctamente`)
      setCreateNewItemModal(false)
      resetNewItemForm()
      getRecord()
    } catch (error) {
      console.log(error)
      toast.error("Error al crear el ítem: " + error)
    } finally {
      setUploadingStatus(false)
    }
  }

  useEffect(() => {
    getRecord()
  }, [page, limit, selectedMonth, selectedYear, selectedWorker, selectedStatus, selectedCategory, selectedSubcategory])

  useEffect(() => {
    getStakeholders()
    getRecord()
    getWorkers()
  }, [])

  useEffect(() => {
    if (search === "") {
      setPage(1)
      getRecord()
    }
  }, [search])

  const [headersTableActive, setHeadersTableActive] = useState([])
  const [openFilter, setOpenFilter] = useState(false)

  useEffect(() => { // Cargar columnas activas del local storage, si no las hay colocar todas activas
    const localActiveHeaders = JSON.parse(localStorage.getItem("activeTableColsInventario")) || [];
    if (localActiveHeaders.length > 0) {
      const sanitized = localActiveHeaders
        .filter((stored) => headers.some((h) => h.id === stored.id))
        .map((stored) => {
          const current = headers.find((h) => h.id === stored.id)
          return { ...current, show: stored.show ?? current.show }
        })
      const missing = headers.filter((h) => !sanitized.some((s) => s.id === h.id))
      const merged = [...sanitized, ...missing]
      setHeadersTableActive(merged)
      localStorage.setItem("activeTableColsInventario", JSON.stringify(merged))
    } else {
      setHeadersTableActive(headers);
    }
  }, []);

  useEffect(() => { // Cada que cambian las columnas activas se guardan en el local storage
    if (headersTableActive.length > 0) {
      localStorage.setItem("activeTableColsInventario", JSON.stringify(headersTableActive));
    }
  }, [headersTableActive]);

  const headers = [
    { id: 1, name: "Acciones", value: "actions", show: true },
    { id: 2, name: "Usuario asignado", value: "userAssigned.name", show: true },
    { id: 3, name: "Fecha de compra", value: "buy.paymentDate", show: true, formatter: (v) => FormatDateString(v) },
    { id: 4, name: "Id de compra", value: "buy.id", show: true },
    { id: 5, name: "Proveedor", value: "buy.stakeholder.commercialName", show: true },
    { id: 6, name: "N° comprobante de pago", value: "buy.receiptNumber", show: true },
    { id: 7, name: "Ítem", value: "itemName", show: true },
    { id: 8, name: "Estado", value: "status", show: true },
    { id: 9, name: "Precio unitario", value: "buy.stakeholderProduct.price", show: true, formatter: (v, row) => ParseNumberToFloat({number: v, currency: row?.currency}) || "-" },
    { id: 10, name: "Foto ítem", value: "images", show: true },
  ]

  /// Crear item
  const [newItem, setNewItem] = useState({
    stakeholder: "",
    purchase: "",
    itemName: "",
    brand: "",
    buy: null,
    unitPrice: "",
    purchaseDate: "",
    serialNumber: "",
    description: "",
    status: "Disponible",
    quantity: 1
  })

  const openEditItem = (item) => {
    setEditItem({
      id: item.id,
      userAssigned: item.userAssigned?.id || item.userAssigned || null,
      status: item.status || "Disponible"
    })
    setEditItemModal(true)
  }

  const updateInventoryItem = async () => {
    try {
      if (!editItem) return
      
      setUploadingStatus(true)

      const isBlockedStatus = editItem.status === "En mantenimiento" || editItem.status === "Fuera de uso"

      const payload = {
        userAssigned: isBlockedStatus ? null : (editItem.userAssigned || null),
        status: editItem.status
      }
      
      await axios.put(`${BACKEND}/api/inventario/${editItem.id}`, payload)
      
      toast.success("Ítem actualizado correctamente")
      setEditItemModal(false)
      setEditItem(null)
      getRecord()
    } catch (error) {
      console.log(error)
      toast.error("Error al actualizar el ítem: " + error)
    } finally {
      setUploadingStatus(false)
    }
  }

  const DeleteItem = async (id) => {
    try {
      const confirm = window.confirm("¿Eliminar este ítem?")
      if (!confirm) return
      await axios.delete(`${BACKEND}/api/inventario/${id}`)
      toast.success("Ítem eliminado")
      getRecord()
    } catch (e) {
      console.log(e)
      toast.error("Error al eliminar el ítem")
    }
  }

  const getCategories = async () => { // Categorías
    try {
      let url = `${BACKEND}/api/stakeholdersProductsCategories?limit=0`
      const response = await axios.get(url)
      setCategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las categorías: " + error)
    }
  }

  const getSubcategories = async () => { // Subcategorías
    try {
      let url = `${BACKEND}/api/stakeholderProductsSubcategories?limit=0`
      if (selectedCategory) url += `&where[category][equals]=${selectedCategory}`
      const response = await axios.get(url)
      setSubcategories(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener las subcategorías: " + error)
    }
  }
  
  useEffect(() => {
    getCategories()
  }, [])

  useEffect(() => {
    if (selectedCategory) {
      getSubcategories()
    } else {
      setSelectedSubcategory("")
      setSubcategories([])
    }
  }, [selectedCategory])

  return (
    <div className="flex flex-col h-screen w-full">

      <FilterHeadersDialog
        activeCols={headersTableActive}
        localStorageKey="activeTableColsInventario"
        defaultCols={headers}
        open={openFilter}
        setOpen={setOpenFilter}
        setActiveCols={setHeadersTableActive}
      />

      <Modal // Modal para crear nuevo ítem
        activeModal={createNewItemModal}
        onClose={() => {
          setCreateNewItemModal(false)
          resetNewItemForm()
        }}
        title="Registrar nuevo ítem"
        className="max-w-4xl"
        centered
      >
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[70vh] overflow-y-auto pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            <InputFormValue
              title="Proveedor"
              maxHeight="max-h-16"
              info="Proveedor del ítem"
              icon={<FaUser />}
              value={newItem.stakeholder}
              setValue={(value) => setNewItem(prev => ({ ...prev, stakeholder: value }))}
              required
              minChars={0}
              type="autocomplete"
              options={stakeholders.map((s) => ({ value: s.id, label: s.commercialName || s.socialReason }))}
              onSelectOption={(opt) => {
                setStakeholderSelected(opt)
                setNewItem(prev => ({ ...prev, stakeholder: opt?.value, purchase: "" }))
                getPurchasesForStakeholder(opt?.value)
              }}
              placeholder="Buscar proveedor..."
            />

            <InputFormValue
              title="Compra"
              info="Selecciona la compra específica del proveedor"
              icon={<FaShoppingCart />}
              value={newItem.purchase}
              setValue={(value) => setNewItem(prev => ({ ...prev, purchase: value }))}
              required={true}
              type="autocomplete"
              minChars={0}
              options={purchases.map((p) => ({ 
                value: p.id, 
                label: `ID: ${p.id} | ${p.stakeholderProduct?.name || 'Sin nombre'} | ${p.paymentDate ? new Date(p.paymentDate).toLocaleDateString() : 'Sin fecha'} | S/.${p.total || 0} | Cant: ${p.quantity || 1}` 
              }))}
              onSelectOption={(opt) => {
                const selectedPurchase = purchases.find(p => p.id === opt?.value)
                setPurchaseSelected(selectedPurchase)
                setNewItem(prev => ({ 
                  ...prev, 
                  purchase: opt?.value,
                  itemName: selectedPurchase?.stakeholderProduct?.name || "",
                  brand: selectedPurchase?.stakeholderProduct?.brand || "",
                  unitPrice: selectedPurchase?.unitPrice || selectedPurchase?.total || "",
                  purchaseDate: selectedPurchase?.paymentDate ? new Date(selectedPurchase.paymentDate).toISOString().split('T')[0] : "",
                  description: selectedPurchase?.description || "",
                  quantity: selectedPurchase?.quantity || 1
                }))
              }}
              placeholder="Seleccionar compra..."
              disabled={!newItem.stakeholder}
            />

            <InputFormValue
              title="Cantidad de items"
              info="Número de unidades a agregar al inventario"
              icon={<FaBox />}
              disabled
              value={newItem.quantity}
              required={true}
              type="number"
              min={1}
              placeholder="1"
            />

            <InputFormValue
              title="Nombre del ítem"
              info="Nombre descriptivo del ítem"
              icon={<FaBox />}
              disabled
              value={newItem.itemName}
              required={true}
              type="text"
              placeholder="Nombre del ítem..."
            />

            {/* <InputFormValue
              title="Marca"
              info="Marca del ítem"
              icon={<FaBox />}
              value={newItem.brand}
              setValue={(value) => setNewItem(prev => ({ ...prev, brand: value }))}
              type="text"
              placeholder="Marca del ítem..."
            /> */}

            <InputFormValue
              title="Fecha de compra"
              info="Fecha en que se realizó la compra"
              icon={<FaBox />}
              value={newItem.purchaseDate}
              disabled
              type="date"
            />

            {/* <InputFormValue
              title="Número de serie"
              info="Número de serie del ítem (opcional)"
              icon={<FaBox />}
              value={newItem.serialNumber}
              setValue={(value) => setNewItem(prev => ({ ...prev, serialNumber: value }))}
              type="text"
              placeholder="Número de serie..."
            /> */}

            {/* <InputFormValue
              title="Estado"
              info="Estado actual del ítem"
              icon={<FaBox />}
              value={newItem.status}
              setValue={(value) => setNewItem(prev => ({ ...prev, status: value }))}
              type="select"
              options={[
                { value: "Disponible", label: "Disponible" },
                { value: "En uso", label: "En uso" },
                { value: "En mantenimiento", label: "En mantenimiento" },
                { value: "Fuera de servicio", label: "Fuera de servicio" }
              ]}
            /> */}

            <InputFormValue
              title="Descripción"
              info="Notas adicionales del ítem"
              icon={<FaBox />}
              value={newItem.description}
              setValue={(value) => setNewItem(prev => ({ ...prev, description: value }))}
              type="textarea"
              placeholder="Descripción del ítem..."
            />
          </div>

          {/* Botones de acción */}
          <div className="flex w-full justify-center items-center gap-2 mt-2">
            <DinamicButton
              action={() => { setCreateNewItemModal(false); resetNewItemForm() }}
              content="Cancelar"
              backgroundColor="#6b7280"
              hoverBackgroundColor="#4b5563"
              width="50%"
            />
            <DinamicButton
              action={createInventoryItem}
              disabled={uploadingStatus}
              content="Registrar ítem"
              icon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <AddIcon size={14} />}
              width="50%"
            />
          </div>
        </div>
      </Modal>

      <Modal // Modal para editar ítem
        activeModal={editItemModal}
        onClose={() => {
          setEditItemModal(false)
          setEditItem(null)
        }}
        title="Editar ítem del inventario"
        className="max-w-2xl"
        centered
      >
        <div>
          <div className="grid grid-cols-1 gap-4 max-h-[70vh] overflow-y-auto pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
            
            <InputFormValue
              title="Estado del ítem"
              info="Estado actual del ítem en el inventario"
              icon={<FaBox />}
              value={editItem?.status || "Disponible"}
              setValue={(value) => setEditItem(prev => ({ ...prev, status: value }))}
              type="select"
              onSelectOption={(opt) => {
                const next = opt?.value
                setEditItem(prev => ({
                  ...prev,
                  status: next,
                  userAssigned: (next === "En mantenimiento" || next === "Fuera de uso") ? null : prev.userAssigned
                }))
              }}
              options={
                editItem?.userAssigned 
                  ? [
                      // Si hay usuario asignado, puede estar en uso, mantenimiento o fuera de uso
                      { value: "En uso", label: "En uso" },
                      { value: "En mantenimiento", label: "En mantenimiento" },
                      { value: "Fuera de uso", label: "Fuera de uso" }
                    ]
                  : [
                      // Si no hay usuario asignado, puede estar disponible, mantenimiento o fuera de uso
                      { value: "Disponible", label: "Disponible" },
                      { value: "En mantenimiento", label: "En mantenimiento" },
                      { value: "Fuera de uso", label: "Fuera de uso" }
                    ]
              }
            />

            <InputFormValue
              title="Usuario asignado"
              info="Selecciona el usuario al que se asignará el ítem"
              icon={<FaUser />}
              value={editItem?.userAssigned || ""}
              setValue={(value) => setEditItem(prev => ({ ...prev, userAssigned: value }))}
              type="select"
              disabled={editItem?.status === "En mantenimiento" || editItem?.status === "Fuera de uso"}
              options={[
                { value: "", label: "Sin asignar" },
                ...workers.map((w) => ({ value: w.id, label: w.name }))
              ]}
              onSelectOption={(opt) => {
                setEditItem(prev => ({ 
                  ...prev, 
                  userAssigned: opt?.value || null,
                  // Si se asigna un usuario, cambiar automáticamente el estado a "En uso"
                  // Si se quita el usuario, cambiar automáticamente a "Disponible"
                  status: opt?.value ? "En uso" : "Disponible"
                }))
              }}
              placeholder={(editItem?.status === "En mantenimiento" || editItem?.status === "Fuera de uso") ? "No disponible en mantenimiento o fuera de uso" : "Seleccionar usuario..."}
            />

            {/* Información del ítem (solo lectura) */}
            <div className="bg-gray-50 p-4 rounded-lg">
              <h4 className="font-semibold text-sm text-gray-700 mb-2">Información del ítem</h4>
              <div className="grid grid-cols-2 gap-2 text-xs">
                <div>
                  <span className="font-medium">Nombre:</span> {record.find(r => r.id === editItem?.id)?.itemName || "-"}
                </div>
                <div>
                  <span className="font-medium">ID de compra:</span> {record.find(r => r.id === editItem?.id)?.buy?.id || "-"}
                </div>
                <div>
                  <span className="font-medium">Proveedor:</span> {record.find(r => r.id === editItem?.id)?.buy?.stakeholder?.commercialName || "-"}
                </div>
                <div>
                  <span className="font-medium">Precio unitario:</span> S/. {record.find(r => r.id === editItem?.id)?.buy?.stakeholderProduct?.price || "-"}
                </div>
              </div>
            </div>
          </div>

          {/* Botones de acción */}
          <div className="flex w-full justify-center items-center gap-2 mt-4">
            <DinamicButton
              action={() => { setEditItemModal(false); setEditItem(null) }}
              content="Cancelar"
              backgroundColor="#6b7280"
              hoverBackgroundColor="#4b5563"
              width="50%"
            />
            <DinamicButton
              action={updateInventoryItem}
              disabled={uploadingStatus}
              content="Actualizar ítem"
              icon={uploadingStatus ? <CircularProgress size={14} className="animate-spin" /> : <FaSave size={14} />}
              width="50%"
            />
          </div>
        </div>
      </Modal>

       {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaBox className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Inventario</h2>
          </div>
        </div>

        <div className="flex flex-row gap-8 items-center justify-center">

          <DinamicButton
            content="Asignaciones de bloque"
            action={() => navigate("/home/asignaciones-bloque")}
          />

          <Selector
            title="Límite"
            setter={setLimit}
            value={limit}
            width="w-[5rem]"
            options={[
              { value: 20, label: "20" },
              { value: 30, label: "30" },
              { value: 40, label: "40" },
              { value: 50, label: "50" },
              { value: 100, label: "100" },
            ]}
          />

          <SearchBar
            value={search}
            setter={setSearch}
            pageSetter={setPage}
            getter={getRecord}
          />

        </div>

      </div>

      {/* Filtros */}
      <div className="flex flex-row px-4 bg-gray-100 mt-0.5">
        <div className="flex flex-row w-full py-1 items-center gap-4 justify-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row w-full gap-4 items-center justify-center px-6">

            <Selector
              title="Mes compra"
              options={[{ value: "", label: "Todos" }, ...months.map((s) => ({ value: s.value, label: s.label }))]}
              value={selectedMonth}
              setter={setSelectedMonth}
              width="w-[6rem]"
            />

            <Selector
              title="Año compra"
              options={[{ value: "", label: "Todos" }, ...years.map((s) => ({ value: s.value, label: s.label }))]}
              value={selectedYear}
              setter={setSelectedYear}
              width="w-[6rem]"
            />

            <Selector
              title="Estado"
              options={[{ value: "", label: "Todos" }, ...itemStatus.map((s) => ({ value: s.value, label: s.label }))]}
              value={selectedStatus}
              setter={setSelectedStatus}
              width="w-[8rem]"
            />

            <div className="pl-4">
              <DinamicButton
                content="Registrar nuevo ítem"
                action={() => setCreateNewItemModal(true)}
                icon={<AddIcon />}
              />
            </div>

            <FilterButton
              content="Headers"
              action={() => setOpenFilter(true)}
            />

          </div>
        </div>
      </div>

      {/* Filtros */}
      <div className="flex flex-row px-4 bg-gray-100 mt-0.5">
        <div className="flex flex-row w-full py-1 items-center gap-4 justify-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row w-full gap-4 items-center justify-center px-6">

            <Selector
              title="Categoría"
              options={[{ value: "", label: "Todos" }, ...categories.map((s) => ({ value: s.id, label: s.categoryName }))]}
              value={selectedCategory}
              setter={(val) => { setSelectedCategory(val); setSelectedSubcategory(""); }}
              width="w-[12rem]"
            />

            <Selector
              title="Subcategoría"
              options={[{ value: "", label: "Todos" }, ...subcategories.map((s) => ({ value: s.id, label: s.subcategoryName }))]}
              value={selectedSubcategory}
              setter={setSelectedSubcategory}
              width="w-[12rem]"
            />

            <Selector
              title="Usuario asignado"
              options={[{ value: "", label: "Todos" }, ...workers.map((s) => ({ value: s.id, label: s.name }))]}
              value={selectedWorker}
              width="w-[12rem]"
              setter={setSelectedWorker}
            />

          </div>
        </div>
      </div>
    
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : (
          record.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                <tr className="text-gray-700 text-center text-xs font-bold">
                  {headersTableActive.filter((h) => h.show).map((h, i) => {
                    return (
                      <td key={i} className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                        {h.name}
                      </td>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {record.map((s) => {
                  return (
                    <ItemRowInventarioStakeholders
                      key={s.id}
                      item={s}
                      headersTableActive={headersTableActive}
                      headers={headers}
                      deleteItem={DeleteItem}
                      setter={setRecord}
                      openEditItem={openEditItem}
                      workers={workers}
                    />
                  )
                })}
              </tbody>
            </table>
          )
        )}
      </div>

      {/* Pagination */}
      <PaginationItem
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"ítems"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(e, v) => setPage(v)}
      />

    </div>
  )
}

export default Inventario